import { Form } from 'antd';
import type { FC } from 'react';
import { useState } from 'react';

import type { Room } from 'app/typings';

import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';
import type { HotelRoomsForm } from '../Types';

import { General } from './General/General';
import { RoomCategories } from './RoomCategories/RoomCategories';
import './RoomsForm.scss';

export const RoomsForm: FC<Props> = ({
  hotel,
  rooms,
  saveHotel,
  saveRoom,
  deleteRoom,
  isNewDataModel = false,
  isLoading = false,
}) => {
  const [form] = Form.useForm();
  const [roomCountIsSet, setRoomCountIsSet] = useState<boolean>(
    !!hotel.roomCount
  );

  const hasNoRoom = !rooms.length;
  // NDM: a hotel may only sell day packages. Total room count stays required.
  const nextDisabled = !roomCountIsSet || (hasNoRoom && !isNewDataModel);

  return (
    <HeaderWrapper
      nextDisabled={nextDisabled}
      handleNext={() => form.submit()}
      isLoading={isLoading}
      nextConfirmTitle={
        isNewDataModel && hasNoRoom
          ? 'Are you sure you do not want to sell rooms on Staycation?'
          : undefined
      }
    >
      <div className="rooms-form-container">
        <div className="rooms-form">
          <div className="section">
            <div className="section-header">
              <div className="title">General</div>
            </div>
            <div className="section-body">
              <General
                form={form}
                roomCount={hotel.roomCount}
                onFinish={saveHotel}
                setRoomCountIsSet={setRoomCountIsSet}
              />
            </div>
          </div>
          <div className="section">
            <div className="section-header">
              <div className="title">Room categories</div>
              <div className="subtitle">Add all your room categories</div>
            </div>
            <div className="section-body">
              <RoomCategories
                rooms={rooms}
                saveRoom={saveRoom}
                deleteRoom={deleteRoom}
                hotelId={hotel.id}
                isNewDataModel={isNewDataModel}
              />
            </div>
          </div>
        </div>
      </div>
    </HeaderWrapper>
  );
};

type Props = {
  saveRoom: (room: Room) => void;
  deleteRoom?: (roomId: number) => void;
  saveHotel: (values: HotelRoomsForm) => void;
  rooms: Room[];
  hotel: HotelRoomsForm & { id: number };
  isNewDataModel?: boolean;
  isLoading?: boolean;
};
